// extracted by mini-css-extract-plugin
module.exports = {"pageNumberButton":"Pagination_pageNumberButton__2_RRk","pageNumberButton_active":"Pagination_pageNumberButton_active__2v5J8","btnControl":"Pagination_btnControl__36512"};